import React, { Component } from "react";
import {fromLonLat} from 'ol/proj';
import OlMap from "ol/Map";
import OlView from "ol/View";
import OlLayerTile from "ol/layer/Tile";
import OlLayerVector from "ol/layer/Vector";
import OlSourceOSM from "ol/source/OSM";
import OlSourceVector from "ol/source/Vector";
import OlFeature from "ol/Feature";
import OlGeomPoint from "ol/geom/Point";
import OlControl from "ol/control/Control";
import Icon1 from "../../img/icon/svg-pin.svg";
import Style from "ol/style/Style";
import Icon from "ol/style/Icon";

import "./Map.css";

class PublicMap extends Component {
  constructor(props) {
    super(props);


    this.state = { center: fromLonLat([-106.66521030750478,26.392488262811835 ]), zoom: 4 };

    this.olmap = new OlMap({
      target: null,
      layers: [
        new OlLayerTile({
          source: new OlSourceOSM()
        })
      ],
      view: new OlView({
        center: this.state.center,
        zoom: this.state.zoom
      })
    });

    var layer = new OlLayerVector({
      source: new OlSourceVector({
          features: [
              new OlFeature({
                  geometry: new OlGeomPoint(fromLonLat([-117.0171094015458,32.445367585303096]))
              })
          ]
      })
    });
    var layer2 = new OlLayerVector({
      source: new OlSourceVector({
          features: [
              new OlFeature({
                  geometry: new OlGeomPoint(fromLonLat([-101.34650448603456, 20.699370833901998]))
              })
          ]
      })
    });

  var iconStyle = new Style({
    image: new Icon({
      zIndex: 100,
      anchor: [.6, 70],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      scale: .7,
      src: Icon1,

    })
  });

  layer.setStyle(iconStyle);
  layer2.setStyle(iconStyle);
  this.olmap.addLayer(layer);
  this.olmap.addLayer(layer2);


  }

  updateMap() {
    this.olmap.getView().setCenter(this.state.center);
    this.olmap.getView().setZoom(this.state.zoom);
  }

  handleMapClick(event){
    //console.log(event);
    //const element = this.olmap.getCoordinateFromPixel(event.pixel);
    //console.log(element);
    var feature = this.olmap.forEachFeatureAtPixel(event.pixel,
      function(feature) {
        return feature;
      });
      if (feature) {
        var geometry = feature.getGeometry();
        var coord = geometry.getCoordinates();
        //alert(coord);
        this.userAction(coord);
       
      } else {
       //alert("Nothing");
      }

  }

  componentDidMount() {
    this.olmap.setTarget("map");

    this.olmap.on('click',(event)=>{
      
      this.handleMapClick(event);
    });

    // Listen to map changes
    this.olmap.on("moveend", () => {
      let center = this.olmap.getView().getCenter();
      let zoom = this.olmap.getView().getZoom();
      this.setState({ center, zoom });
    });

    
    /* Custom OLMap Control */
    var button = document.createElement('button');
    button.className='btnReset';
    button.innerHTML = 'x';
    
    
    button.addEventListener('click', ()=>{
        this.handleReset();
    });
    
    var element = document.createElement('div');
    element.className = 'ol-unselectable ol-control ol-reset-control';
    element.appendChild(button);
    
    var resetControl = new OlControl({
        element: element
    });
    this.olmap.addControl(resetControl);
  }

  shouldComponentUpdate(nextProps, nextState) {
    let center = this.olmap.getView().getCenter();
    let zoom = this.olmap.getView().getZoom();
    if (center === nextState.center && zoom === nextState.zoom) return false;
    return true;
  }

  userAction(coords) {
    this.olmap.getView().animate({ zoom: 4 }, { center: coords }, { duration: 1500 });
    this.olmap.getView().animate({ zoom: 15 }, { center: coords }, { duration: 1500 });
    //this.setState({ center: [546000, 6868000], zoom: 5 });
  }

  handleReset(){
    this.olmap.getView().animate({ zoom: 4 }, { center: fromLonLat([-106.66521030750478,26.392488262811835 ]) }, { duration: 2000 });
  }

  render() {
    this.updateMap(); // Update map on render?
    return (
      <div id="map">
          {/* <button type="button" className="btnReset" onClick={()=>this.handleReset()}> X </button> */}
      </div>
    );
  }
}

export default PublicMap;
